import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";


import { CasinoLink } from '../Layout/CasinoLink.jsx'



export class AccountTabletLinkovi extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return <div className="account-menu mobile-hidden">
            <div className="as-block">
                <div className="sidebar-menu">
                    <span className="sidebar-menu--header">Casino račun</span>
                    <NavLink className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, '/account')}><span>Račun</span></NavLink>

                    <NavLink activeClassName="selected" className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, '/account/bonuses')} >
                        <span>Bonusi</span>
                    </NavLink>

                    <NavLink activeClassName="selected" className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, '/account/superklub')} >
                        <span>SuperKlub</span>
                    </NavLink>

                    <NavLink activeClassName="selected" className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, '/account/superspin')} >
                        <span>SuperSpin</span>
                    </NavLink>

                    <NavLink activeClassName="selected" className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, '/obavijesti')} >
                        <span>Obavijesti</span>
                    </NavLink>

                    <NavLink activeClassName="selected" className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, '/account/games')} >
                        <span>Odigrane igre</span>
                    </NavLink>

                    <NavLink activeClassName="selected" className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, '/account/free-games')} >
                        <span>Odigrane besplatne igre</span>
                    </NavLink>

                    <NavLink activeClassName="selected" className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, '/account/transactions')} >
                        <span>Transakcije</span>
                    </NavLink>

                    <NavLink activeClassName="selected" className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, 'account/privacy')}>
                        <span>Postavke privatnosti</span>
                    </NavLink>

                    <NavLink activeClassName="selected" className="sidebar-menu--link" to={this.props.getHomePathFn(this.props.route.location, '/vip')} >
                        <span>Vip</span>
                    </NavLink>

                    {<CasinoLink className="sidebar-menu--link" href={casino.config.urls.web + "racun/superpredah"}><span>SuperPredah</span><span className="icon ico-expand-outline"></span></CasinoLink>}
                    {this.props.user.samoIskljucen ? <a className="link link-20 sidebar-menu--link" href="https://m.supersport.hr/racun#/samoiskljucenje" target="_blank">Samoisključenje</a> : null}
                </div>
                <CasinoLink href={casino.config.urls.sportRacun} className="as-block margin-top btn-2"><span>Sport račun</span><span className="icon ico-expand-outline"></span></CasinoLink>
            </div>
        </div>
    }
}